var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"haveNotThisPage"},[_c('p',[_vm._v("您找的页面不见了，返回首页继续浏览吧")]),_c('button',{on:{"click":_vm.gotoHome}},[_vm._v("返回首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }